<template>
  <page-view title>
    <div :style="{marginBottom:'10px'}">
      <demo-video-alert name="HuiFuSheZhi"></demo-video-alert>
    </div>
    <a-spin :spinning="PullLoading">
      <a-card title="回复设置" :bordered="false" :style="{ height: '100%' }">
        <template slot="extra">
          <search-robot-input class="search-robot-input"
            :showInfo="false" :selectFirst="false" primaryBtnText="拉取配置"
            @changeRobotId="onChangeRobotId"></search-robot-input>
        </template>

        <a-alert
          v-if="!currentRobotId" :style="{margin: '10px 0 20px 0'}" message="重要提醒"
          description="当前显示的系统默认数据，如需加载指定机器人数据请在右上角输入框进行拉取配置操作。"
          type="warning" show-icon />

        <a-alert
          v-if="currentRobotId" :style="{margin: '10px 0 20px 0'}" message="已经拉取机器人配置"
          type="success" show-icon />

        <a-row :gutter="8">
          <a-form>
            <a-form-item label="隐藏回复内容为空的项" :label-col="{ span: 4 }" :wrapper-col="{ span: 12 }">
              <a-switch v-model="hiddenNotUsed" />
            </a-form-item>
          </a-form>
        </a-row>
        
        <a-row :gutter="8">
          <!-- 左侧的菜单栏 -->
          <a-col :span="4">
            <a-menu v-model="cate" :mode="'inline'" :theme="'light'">
              <a-menu-item :key="'all'">全部</a-menu-item>
              <a-menu-item v-for="(item) in cate_data" :key="item.id">{{item.title}}</a-menu-item>
            </a-menu>
          </a-col>

          <a-col :span="20">
            <a-table :columns="columns" :dataSource="list" :rowKey="'id'" :pagination="false">
              <span slot="content" slot-scope="text">
                <span v-line-clamp="1">{{ text }}</span>
              </span>
              <span slot="action" slot-scope="text, record">
                <template>
                  <a @click="$refs.editModal.show({content: record.content, id:record.id, nouns:record.nouns})">修改</a>
                </template>
              </span>
            </a-table>
          </a-col>
        </a-row>
      </a-card>

      <a-card :bordered="false" :style="{ height: '100%', marginTop: '16px' }">
        <a-form :form="form" @submit="handleSubmit">
          <a-form-item label="选择推送机器人"
            :label-col="{xs: { span: 24 },sm: { span: 4 }}" :wrapper-col="{xs: { span: 24 },sm: { span: 10 }}">
            <robot-multiple v-decorator="['robotids',{rules: [{required: true, message: '必填项'}]}]"></robot-multiple>
          </a-form-item>
          <a-form-item :wrapper-col="{xs: { span: 12, offset: 0 },sm:  { span: 12, offset: 4 }}">
            <a-button htmlType="submit" type="primary">推送</a-button>
          </a-form-item>
        </a-form>
      </a-card>
    </a-spin>
    
    <edit-modal ref="editModal" @ok="handleEditSuccess"></edit-modal>
  </page-view>
</template>

<script>

const columns = [
  {
    title: '名称',
    dataIndex: 'name',
    width: 200
  },
  {
    title: '回复内容',
    dataIndex: 'content',
    scopedSlots: { customRender: 'content' }
  },
  {
    title: '操作',
    width: '80px',
    scopedSlots: { customRender: 'action' }
  }
]
import STree from '@/components/Tree/Tree'
import { PageView } from '@/layouts'
import { CATE_DATA, list } from './data'
import RobotMultiple from '@/views/components/RobotMultiple'
import SearchRobotInput from '@/views/components/SearchRobotInput'
import EditModal from './modules/EditModal'
import DeviceApi from '@/api/device'
import { get } from 'http'
import { mapActions } from 'vuex'
import DemoVideoAlert from '@/views/components/DemoVideoAlert'
export default {
  components: {
    PageView,
    STree,
    RobotMultiple,
    SearchRobotInput,
    EditModal,
    DemoVideoAlert
  },
  data() {
    return {
      form: this.$form.createForm(this),
      cate: ['all'],
      // 查询参数
      queryParam: {},
      // 表头
      columns: columns,
      data: [],
      cate_data: CATE_DATA,
      PullLoading: false,
      hiddenNotUsed: false,
      currentRobotId: null
    }
  },
  computed: {
    list() {
      const cate = this.cate
      let list = this.data
      if (this.hiddenNotUsed) {
        // 隐藏回复内容为空的项
        list = list.filter(item => {
          return item.content != ''
        })
      }
      // return list
      if (cate[0] === 'all') {
        return list
      } else {
        return list.filter(item => {
          return cate.includes(item.cate)
        })
      }
    }
  },
  created() {
    this.getData()
  },
  methods: {
    ...mapActions(['BatchpushTask', 'TaskDrawerSwitch', 'demoSetVideo']),
    // 选择机器人
    onChangeRobotId(id) {
      this.currentRobotId = id
      this.getData(id)
    },
    handleEditSuccess({ id, content }) {
      this.data = this.data.map(item => {
        if (item.id == id) {
          item.content = content
        }
        return item
      })
    },
    // 获取配置信息（获取回复设置配置信息）
    getData(robotid) {
      this.PullLoading = true
      DeviceApi.getDialogueSettingInfo({ sub_id: robotid })
        .then(res => {
          if (res.code === 1) {
            this.data = res.data
          } else {
            this.$message.error(res.msg)
          }
        })
        .finally(() => {
          this.PullLoading = false
        })
    },
    // 提交
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          const data = {
            response_config: JSON.stringify(this.data)
          }
          this.BatchpushTask({
            robotids: values.robotids,
            descs: '账户配置',
            apiFun: sub_id => {
              return DeviceApi.saveDialogueSettingInfo(Object.assign({ sub_id: sub_id }, data))
            }
          })
          this.TaskDrawerSwitch({ status: true })
          this.form.resetFields('robotids')
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .ant-card-extra {
  padding: 0;
}
.custom-tree {
  /deep/ .ant-menu-item-group-title {
    position: relative;
    &:hover {
      .btn {
        display: block;
      }
    }
  }
  /deep/ .ant-menu-item {
    &:hover {
      .btn {
        display: block;
      }
    }
  }
  /deep/ .btn {
    display: none;
    position: absolute;
    top: 0;
    right: 10px;
    width: 20px;
    height: 40px;
    line-height: 40px;
    z-index: 1050;
    &:hover {
      transform: scale(1.2);
      transition: 0.5s all;
    }
  }
}
</style>
